import { Text, VStack, useColorModeValue } from "@chakra-ui/react";

export const StatBadge = ({ label, value, color, size = "md" }) => {
  const bgColor = useColorModeValue("white", "gray.700");
  const borderColor = useColorModeValue("gray.200", "gray.600");
  const textColor = useColorModeValue("gray.600", "gray.300");

  const sizes = {
    sm: { value: "lg", label: "sm" },
    md: { value: "xl", label: "md" },
    lg: { value: "2xl", label: "lg" }
  };

  return (
    <VStack
      spacing={1}
      p={size === "lg" ? 4 : 3}
      bg={bgColor}
      borderRadius="xl"
      border="1px"
      borderColor={borderColor}
      shadow="md"
      minW="100px"
      transition="all 0.2s"
      _hover={{ shadow: "lg", transform: "translateY(-2px)" }}
    >
      <Text
        fontSize={sizes[size].value}
        fontWeight="bold"
        color={`${color}.600`}
        lineHeight={1}
      >
        {value}
      </Text>
      <Text fontSize={sizes[size].label} color={textColor} fontWeight="medium">
        {label}
      </Text>
    </VStack>
  );
};
